






















































































import { Locale } from 'vue-i18n';
import { Component, Vue } from 'vue-property-decorator';
import { Product, AnnouncementSetting, _Boolean } from '@/API';
import { updateMenuList } from '@/appsync/lambda/CallUpdateMenuService';
import { updateUserSchema } from '@/appsync/lambda/updateUserSchemaService';
import { updateIsReadStatus } from '@/appsync/service/AnnouncementMutationService';
import {
  fetchLoginUserAllInfoWithAnnouncementSetting,
  editMenus,
} from '@/appsync/service/LoginUserAllInfoQueryService';
import { updateUsageFavorite } from '@/appsync/service/LoginUserMutationService';
import { userInfo } from '@/appsync/service/LoginUserQueryService';
import { fetchMenus, fetchSourceIp } from '@/appsync/service/MenuQueryService';
import { updateFavoriteStatus } from '@/appsync/service/MutateService';
import { updateAccessedTimeStamp } from '@/appsync/service/PortalHistoryMenuMutationService';
import {
  updateLinkMenus,
  UpdateLinkMenusParam,
} from '@/appsync/service/PortalLinkMenuMutationService';
import { getIsPortalEnabledStatus } from '@/appsync/service/SystemSettingQueryService';
import {
  fetchTenantLandscapeAllInfo,
  gatewayServer,
  isInHouseIP,
} from '@/appsync/service/TenantLandscapeAllInfoQueryService';
import PortalUserInfoPanel from '@/components/organisms/PortalUserInfoPanel.vue';
import { getUrlTarget } from '@/containers/globals/Util';
import {
  refreshStores,
  refreshStoresOnLoaded,
} from '@/containers/globals/globalSharedService';
import PageNotFound from '@/containers/pages/PageNotFound.vue';
import PortalAnnouncements from '@/containers/templates/PortalAnnouncements.vue';
import PortalAppBar from '@/containers/templates/PortalAppBar.vue';
import PortalFavoriteMenus from '@/containers/templates/PortalFavoriteMenus.vue';
import PortalHistoryMenus from '@/containers/templates/PortalHistoryMenus.vue';
import PortalLinkMenus from '@/containers/templates/PortalLinkMenus.vue';
import PortalNotificationBody from '@/containers/templates/PortalNotificationBody.vue';
import PortalProductRootMenus, {
  ProductRootMenu,
} from '@/containers/templates/PortalProductRootMenus.vue';
import { i18n } from '@/plugins/i18n/i18n';
import router from '@/router';
import { createProductRootMenu } from '@/services/productRootMenuCreateService';
import { commonModule } from '@/store/modules/CommonStore';
import { loginUserModule } from '@/store/modules/LoginUserStore';
import {
  ID,
  ProductMenu,
  LinkMenu,
  UserInfo,
  LoginInfo,
  TenantLandscape,
  UpdateTimeStampQueryParam,
  ClickProductUrlEvent,
  ChangeEvent,
  ProductAdditionalQueryMap,
  ProductMenuMap,
  GetGatewayServerType,
  UserAnnouncement,
  UpdateUserAnnouncementQueryParam,
} from '@/types/type';
import { _BooleanEnum2boolean, getDisabledRoutes } from '@/utils/CommonUtils';
import { REL, PAGE_PATH_BY_NAME } from '@/utils/consts';

@Component({
  components: {
    PortalAppBar,
    PortalFavoriteMenus,
    PortalHistoryMenus,
    PortalLinkMenus,
    PortalNotificationBody,
    PortalAnnouncements,
    PortalUserInfoPanel,
    PageNotFound,
    PortalProductRootMenus,
  },
})
export default class Portal extends Vue {
  private loading: boolean = true;
  private loadingFavoriteMenu: boolean = false;
  private isPortalEnabled: boolean = true;
  private hasHomePermission: boolean = false;
  private loadingLinks: boolean = false;
  private gatewayServerCWS: GetGatewayServerType = gatewayServer;
  private gatewayServerCSR: GetGatewayServerType = gatewayServer;
  private announcementSetting: AnnouncementSetting = AnnouncementSetting.UseV1;
  private userIps: string[] | null = null;
  private linkMenuList: LinkMenu[] = [];
  private productAdditionalQueryMap: ProductAdditionalQueryMap = {};
  private loginUserInfo: UserInfo = userInfo;
  private menusQueryResult = {};
  private userAnnouncements: UserAnnouncement[] = [];
  private notificationHtml: string | null = null;
  private eventHtml: string | null = null;
  private favoriteMenuList: ProductMenu[] = [];
  private historyMenuList: ProductMenu[] = [];
  private productRootMenus: ProductRootMenu[] = [];

  private changeFlag: boolean = false;

  private disableDueToNotInHouseDescription: string = i18n.tc(
    'portal.disableDueToNotInHouse'
  );

  public async created(): Promise<void> {
    const loginInfo: LoginInfo = commonModule.loginInfo;
    const tenantLandscape: TenantLandscape = commonModule.tenantLandscape;
    const userAnonymousId: string = commonModule.userAnonymousId;
    const disabledRoutes = await getDisabledRoutes(
      loginInfo.tenant,
      loginInfo.landscape,
      loginInfo.loginName
    );

    this.isPortalEnabled = await getIsPortalEnabledStatus(
      loginInfo.tenant,
      loginInfo.landscape
    );

    // ホーム画面の権限チェック
    if (!disabledRoutes.includes(PAGE_PATH_BY_NAME.portal)) {
      this.hasHomePermission = true;
    }

    if (!this.isPortalEnabled) {
      router.push(PAGE_PATH_BY_NAME.eventCalendarForMonth);
    }
    // Start updating backend information.
    // Since the contents of UserInfo such as userSchema are also updated by these,
    // should execute it before refreshStores
    const _updateMenuList = updateMenuList(loginInfo, userAnonymousId);
    const _updateUserSchema = updateUserSchema(loginInfo, userAnonymousId);
    await Promise.all([_updateMenuList, _updateUserSchema]);

    const _fetchTenantLandscapeAllInfo = fetchTenantLandscapeAllInfo(
      tenantLandscape
    ).then(tenantLandscapeAllInfo => {
      this.gatewayServerCWS = tenantLandscapeAllInfo.gatewayServerCWS;
      this.gatewayServerCSR = tenantLandscapeAllInfo.gatewayServerCSR;
      this.productAdditionalQueryMap =
        tenantLandscapeAllInfo.productAdditionalQueryMap;
      this.linkMenuList = tenantLandscapeAllInfo.linkMenus;
      this.announcementSetting = tenantLandscapeAllInfo.announcementSetting;
    });
    const _fetchSourceIp = fetchSourceIp().then(userIps => {
      this.userIps = userIps;
    });
    await Promise.all([_fetchTenantLandscapeAllInfo, _fetchSourceIp]);
    /** NOTE: 更新済みのannouncementSettingを使用するため、_fetchTenantLandscapeAllInfoが完了後に実行する */
    await fetchLoginUserAllInfoWithAnnouncementSetting(
      loginInfo,
      this.announcementSetting
    ).then(loginUserAllInfo => {
      this.loginUserInfo = loginUserAllInfo.userInfo;
      this.menusQueryResult = loginUserAllInfo.menusQueryResult;
      this.notificationHtml = loginUserAllInfo.cwsNotificationHtml;
      this.eventHtml = loginUserAllInfo.cwsEventHtml;
      this.userAnnouncements = loginUserAllInfo.userAnnouncements;
    });

    // Update local storage information
    await refreshStoresOnLoaded(
      this.loginUserInfo,
      this.productAdditionalQueryMap
    );

    const productMenuMap: ProductMenuMap = editMenus(
      this.menusQueryResult,
      this.productAdditionalQueryMap,
      this.loginUserInfo ? this.loginUserInfo.language : 'ja',
      isInHouseIP(this.userIps, this.gatewayServerCWS),
      isInHouseIP(this.userIps, this.gatewayServerCSR),
      this.disableDueToNotInHouseDescription
    );
    this.favoriteMenuList = productMenuMap.favoriteMenuList;
    this.historyMenuList = productMenuMap.historyMenuList;

    this.productRootMenus = this.createProductRootMenuList();

    this.loading = false;
  }

  private createProductRootMenuList(): ProductRootMenu[] {
    const hostname: string = location.hostname;
    const tenantLandscape: TenantLandscape = commonModule.tenantLandscape;
    const menus: ProductMenu[] = [];
    menus.push(
      createProductRootMenu(
        loginUserModule.userInfo.canUseCsr,
        hostname,
        tenantLandscape,
        Product.CSR,
        loginUserModule.productAdditionalQueryMap
      )
    );
    menus.push(
      createProductRootMenu(
        loginUserModule.userInfo.canUseCws,
        hostname,
        tenantLandscape,
        Product.CWS,
        loginUserModule.productAdditionalQueryMap
      )
    );
    menus.push(
      createProductRootMenu(
        loginUserModule.userInfo.canUseCtm,
        hostname,
        tenantLandscape,
        Product.CTM,
        loginUserModule.productAdditionalQueryMap
      )
    );
    menus.push(
      createProductRootMenu(
        loginUserModule.userInfo.canUseCjk,
        hostname,
        tenantLandscape,
        Product.CJK,
        loginUserModule.productAdditionalQueryMap
      )
    );
    return menus.filter(menu => menu.available);
  }

  private async disableFavorite(): Promise<void> {
    await updateUsageFavorite({ ...commonModule.loginInfo, usage: false });
    await refreshStores(commonModule.loginInfo, {
      forceReload: { userInfo: true },
    });
  }

  private async afterMenuOpen(event: ClickProductUrlEvent): Promise<void> {
    const loginInfo: LoginInfo = commonModule.loginInfo;
    const { menuId, product, url } = event;
    const param: UpdateTimeStampQueryParam = { ...loginInfo, menuId, product };
    updateAccessedTimeStamp(param);
    window.open(url, getUrlTarget(product), REL);
  }

  private changeInSubItem(e: ChangeEvent) {
    this.changeFlag = e.change;
  }

  private get useFavorite(): boolean {
    return loginUserModule.userInfo.useFavoritePanel;
  }

  private get userInfo(): UserInfo {
    return loginUserModule.userInfo;
  }

  private get loginInfo(): LoginInfo {
    return commonModule.loginInfo;
  }

  private get canEditLink(): boolean {
    return (this as any).$hasPermission('menus.settings');
  }

  private get changeExists(): boolean {
    return this.changeFlag;
  }

  private get isAnnouncementV1Used(): boolean {
    return this.announcementSetting === AnnouncementSetting.UseV1;
  }

  private get isAnnouncementV2Used(): boolean {
    return this.announcementSetting === AnnouncementSetting.UseV2;
  }

  private async changeFavoriteManus(menuIds: ID[]): Promise<void> {
    this.loadingFavoriteMenu = true;
    const loginInfo: LoginInfo = commonModule.loginInfo;
    updateFavoriteStatus({ ...loginInfo, menuIds });
    const favoriteMenus = await fetchMenus({
      ...loginInfo,
      menuIds,
      language: loginUserModule.userInfo.language,
      productAdditionalQueryMap: loginUserModule.productAdditionalQueryMap,
    });
    this.favoriteMenuList = favoriteMenus;
    this.loadingFavoriteMenu = false;
  }

  private async changeLinkMenus(menus: LinkMenu[]): Promise<void> {
    this.loadingLinks = true;
    this.linkMenuList = menus;
    const tenantLandscape: TenantLandscape = commonModule.tenantLandscape;
    const param: UpdateLinkMenusParam = { ...tenantLandscape, menus };
    await updateLinkMenus(param);
    this.loadingLinks = false;
  }

  private async changeIsReadSatus(
    param: UpdateUserAnnouncementQueryParam
  ): Promise<void> {
    if (param) {
      const loginInfo: LoginInfo = commonModule.loginInfo;
      await updateIsReadStatus(
        loginInfo.tenant,
        loginInfo.landscape,
        loginInfo.loginName,
        param.announcementId,
        param.displayStartDate
      );
    }
  }
}
